import { FC, ReactNode } from 'react';
import { Svg } from '@hopskipdrive/react-components';

import { Accordion } from '../../../shared/components/Accordion';
import { colorTokens } from '../../../shared/components/variables';
import { ErrorBoundary } from '../../../shared/utils/errorReporting/ErrorBoundary';
import { LiveAlertDetails } from '../../types/alert';

import { LiveAlerts } from './LiveAlerts';

interface AlertNavDrawerProps {
  isDrawerOpen: boolean;
  isFetching: boolean;
  handleOpenDrawer: (isOpen: boolean) => void;
  rideLiveAlerts?: LiveAlertDetails[];
  timeZone: string;
  children: ReactNode;
}

export const AlertNavDrawer: FC<AlertNavDrawerProps> = ({
  rideLiveAlerts,
  isFetching,
  timeZone,
  isDrawerOpen,
  handleOpenDrawer,
  children,
}) => {
  return (
    <Accordion
      data-testid="info-nav-drawer"
      square={true}
      expanded={isDrawerOpen}
      onChange={() => handleOpenDrawer(!isDrawerOpen)}
    >
      <Accordion.Header expandIcon={<Svg icon="expand-less-filled" style={{ color: colorTokens.primary.main }} />}>
        <ErrorBoundary>
          <LiveAlerts rideAlerts={rideLiveAlerts} timeZone={timeZone} isFetching={isFetching} />
        </ErrorBoundary>
      </Accordion.Header>
      <Accordion.Body>{children}</Accordion.Body>
    </Accordion>
  );
};
